import React from 'react'
import styled from 'styled-components'
import OpenSourcePage from '../components/MarketingSite/Pages/OpenSource/OpenSourcePage'

const OpenSource = () => {
  return <OpenSourcePage />
}

export default styled(OpenSource)``
